module.exports = __webpack_public_path__ + "img/background_img_three.6111bcfa.png";